import { Content, Flex, StrokeIcon } from '@acsbe/ui';
import { useEffect, useState } from 'react';
import { useDomainSelection } from '../../../context';

const VisitReportBanner = () => {
  const { visitCountReport, domain } = useDomainSelection();

  const [monthlyVisitsStr, setMonthlyVisitsStr] = useState<string>('');

  useEffect(() => {
    if (visitCountReport?.averageMonthlyTraffic) {
      setMonthlyVisitsStr(
        visitCountReport.averageMonthlyTraffic.toLocaleString('en-US'),
      );
    } else {
      setMonthlyVisitsStr('');
    }
  }, [visitCountReport?.averageMonthlyTraffic]);

  return (
    <Flex
      row
      align="center"
      gap={2}
      padding={4}
      style={{ backgroundColor: '#F2F6FF', borderRadius: '8px' }}
    >
      <StrokeIcon name="QuestionMarkWithCircle" size={20} />
      {monthlyVisitsStr && (
        <Content>
          {' '}
          {domain} averages{' '}
          <span style={{ color: '#136EF8', fontWeight: 'bold' }}>
            {monthlyVisitsStr}
          </span>{' '}
          visits / month
        </Content>
      )}
      {!monthlyVisitsStr && (
        <Content>Choose as per {domain} visits / month</Content>
      )}
    </Flex>
  );
};

export { VisitReportBanner };
